import { formatters } from '@utils/formattersV2';
import { DonutChartWithTitle } from '../Charts/DonutChartWithTitle';
import { channelNames } from './SalesMetrics';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { Lci3SalesMetrics } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';

type IncrementalSalesDonutChartProps = {
  salesMetrics: Lci3SalesMetrics;
};

export const IncrementalSalesDonutChart = (
  props: IncrementalSalesDonutChartProps
) => {
  return (
    <DonutChartWithTitle
      title="Incremental Sales"
      formatter={value =>
        formatters.currency(value, { full: true, decimals: 0 })
      }
      data={[
        {
          name: channelNames.online,
          value: props.salesMetrics.incrementalSales.online ?? 0,
          color: unifiedPlatformColorPalette.chartDarkGreen,
        },
        {
          name: channelNames.inStore,
          value: props.salesMetrics.incrementalSales.inStore ?? 0,
          color: unifiedPlatformColorPalette.chartLightGreen,
        },
      ]}
    />
  );
};
